<template>
  <bita-modal
    id="wallet-report"
    :title="` گزارش مالی : ${driver.name} `"
    :modal-lg="true"
    :isLoading="isLoadingModal"
    @close="onCloseModal"
  >
    <div slot="body">
      <div class="row">
        <bita-datepicker
          type="date"
          id="fromDate"
          validation-container-class="col-lg-4"
          name="from-date"
          label="از تاریخ"
          inputClass="form-control"
          @change="loadData"
          v-model="filter.fromDate"
        />
        <bita-datepicker
          type="date"
          id="toDate"
          validation-container-class="col-lg-4"
          name="from-date"
          label="تا تاریخ"
          inputClass="form-control"
          @change="loadData"
          v-model="filter.toDate"
        />
        <bita-select
          name="status"
          label="نوع"
          ref="statusDropDown"
          validation-container-class="col-lg-4"
          input-class="form-control"
          :data-source="statuses"
          data-text-field="name"
          data-value-field="id"
          v-model="filter.status"
          @change="loadData"
        />
      </div>
      <bita-grid
        ref="logGrid"
        v-if="showGrid"
        :columns="gridColumns"
        :read-data="readData"
        :grid-server-side="true"
        :schema-total="'total'"
        :schema-data="'data'"
        :server-paging="true"
        :batch="true"
        :resizable="true"
        :page-size="pageSize"
        :current-page="currentPage"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  data() {
    return {
      isLoadingModal: false,
      showGrid: false,
      driver: {},
      pageSize: 0,
      currentPage: 0,
      total_amount: "",
      total_balance: "",
      fullName: "",
      filter: {},
      statuses: [
        { id: 28, name: "شارژ کیف پول" },
        { id: 45, name: "خرید بلیط" },
        { id: 60, name: "پیامک اعلام بار" },
        { id: 61, name: "تسویه شده" },
      ],
      gridColumns: [
          { title: "#", template: this.$getTemplate, width: "40px" },
          {
            field: "tracking_code",
            title: "کد‌پیگیری کیف پول",
            template: (e) => (e.tracking_code ? e.tracking_code : " - "),
            width: 110,
          },
          {
            field: "amount",
            title: this.$currencyLabel("مبلغ"),
            footerTemplate: (e) =>
              e ? ` جمع کل  ${this.$thousandSeprator(this.total_amount)}` : "",
            template: (e) => {
              if (e.payment_state)
                return e.amount
                  ? `<i class="fas fa-sort-up"></i> ${this.$thousandSeprator(
                      e.amount
                    )}`
                  : " - ";
              return e.amount
                ? `<i class="fas fa-sort-down"></i> ${this.$thousandSeprator(
                    e.amount
                  )}`
                : " - ";
            },
            width: 150,
          },
          {
            field: "type_name",
            title: "نوع",
            width: 110,
          },
          {
            filed: "description",
            title: "توضیحات",
            template: (e) => (e.description ? e.description : "-"),
            width: 150,
          },
          {
            filed: "created_at",
            title: "تاریخ",
            template: (e) =>
              e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
            width: 130,
          },
        ],
    };
  },
  methods: {
    setInitialData(_driver) {
      this.showGrid = true;
      this.driver = _driver;
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingModal = true;
      let baseUrl = `/drivers/wallet-report?page=${this.currentPage}&page_size=${this.pageSize}&user_id=${this.driver.user.id}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filter, "&");
      this.$persistClient("get", url)
        .then((res) => {
          this.fullName = this.driver.name;
          this.total_amount = res.data.data.total_amount;
          e.success(res.data.data.data);
        })
        .catch(() => e.success([]))
        .finally(() => (this.isLoadingModal = false));
    },
    onCloseModal() {
      this.showGrid = false;
    },
    loadData() {
      this.$refs.logGrid.loadDataSource();
    },
  },
};
</script>
